import { FC } from 'react';
import { Partner, Society, User } from 'types';
import { DetailsProfileBadge } from 'modules/_shared/components/Sections/DetailsProfileSection';
import PartnerAside from '../PartnerAside';

type PartnerAsideData = {
  user: User;
  isAdmin: boolean;
  actualPartner: Partner | null;
  actualSociety: Society | null;
  incorporationDate: string | null;
  setIsCardVisible: (isVisible: boolean) => void; // eslint-disable-line
  setPage: (page: string) => void; // eslint-disable-line
  isLoading: boolean;
  inversion: number;
  badges?: DetailsProfileBadge[];
};

type PartnerAsideWrapperProps = {
  isCardVisible: boolean;
  screenShowAside: string;
  handleClick: () => void;
  data: PartnerAsideData;
};

const PartnerAsideWrapper: FC<PartnerAsideWrapperProps> = ({
  isCardVisible,
  screenShowAside,
  handleClick,
  data,
}) => {
  const {
    user,
    isAdmin,
    actualPartner,
    actualSociety,
    incorporationDate,
    setIsCardVisible,
    setPage,
    isLoading,
    inversion,
    badges,
  } = data;

  return (
    <>
      {isCardVisible && (
        <div
          className={
            isCardVisible
              ? `card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-${screenShowAside} toggle-screen-${screenShowAside} content-active`
              : `card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-${screenShowAside} toggle-screen-${screenShowAside}`
          }
          data-content="userAside"
          data-toggle-screen={screenShowAside}
          data-toggle-overlay="true"
          data-toggle-body="true"
        >
          <div className="card-inner-group">
            <div className="simplebar-wrapper">
              <div className="simplebar-height-auto-observer-wrapper">
                <div className="simplebar-height-auto-observer" />
              </div>
              <div className="simplebar-mask">
                <div className="simplebar-offset">
                  <div className="simplebar-content-wrapper">
                    <div className="simplebar-content">
                      <ul>
                        <li
                          className={`nav-item nav-item-trigger d-${screenShowAside}-none m-4`}
                        >
                          <p
                            className="toggle btn btn-icon btn-trigger"
                            data-target="userAside"
                            onClick={handleClick}
                          >
                            <em className="icon ni ni-cross" />
                          </p>
                        </li>
                      </ul>
                      <PartnerAside
                        user={user}
                        isAdmin={isAdmin}
                        isLoading={isLoading}
                        partner={actualPartner}
                        society={actualSociety}
                        partnerNumber={actualPartner?.partnerNumber}
                        incorporationDate={incorporationDate}
                        setIsCardVisible={setIsCardVisible}
                        setPage={setPage}
                        inversion={inversion}
                        badges={badges}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="simplebar-placeholder" />
          </div>

          <div className="simplebar-track simplebar-horizontal">
            <div className="simplebar-scrollbar" />
          </div>
          <div className="simplebar-track simplebar-vertical">
            <div className="simplebar-scrollbar" />
          </div>
        </div>
      )}
    </>
  );
};

export default PartnerAsideWrapper;
